var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SharedPublishingArticle', {
    attrs: {
      "pageTitle": _vm.$t('components.sub.navigation.press-releases'),
      "allArticlesUrl": _vm.sectionRoot,
      "viewAllArticlesLink": _vm.$t('scenes.publishing.view-all-press-releases'),
      "viewAllArticlesButton": _vm.$t('scenes.publishing.view-all-press-releases-button'),
      "article": _vm.pr,
      "author": null
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }